import { Badge, Button } from "@/components/common";
import HeroBusiness from "@/components/common/HeroBusiness";
import PageTitleBox from "@/components/common/PageTitleBox";
import SectionTitle from "@/components/home/SectionTitle";
import Container from "@/components/layout/Container";
import { Link } from "react-router-dom";

const BusinessAICC = () => {
  return (
    <Container>
      <HeroBusiness title="비즈니스를 완성하는" />

      <main className="py-[70px]">
        {/* Hero Section */}
        <PageTitleBox
          badge="문자콜센터"
          badgeColor="navy"
          title={
            <>
              복잡한 개발 없이 삽입 즉시 시작되는
              <br />
              비즈니스 메신저<strong className="text-[#1976D2]"> 문자콜센터</strong>
            </>
          }
          subtitle={
            <>
              별도의 앱 설치나 복잡한 연동 없이,
              <br />
              스크립트를 넣어 이용 가능한 문의 상담 톡 서비스입니다.
            </>
          }
        />

        {/* Problem Section */}
        <section className="mb-[80px]">
          <div className="mb-6">
            <Badge size="md" className="bg-[#e74c3c]" color="white">
              문제점
            </Badge>
          </div>
          {/* Customer Problem */}
          <div className="mb-8">
            <h3 className="text-[2rem] font-bold mb-4">번호 저장하다 지치는 고객</h3>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div className="flex items-start gap-4 p-6 bg-white border border-gray-1 rounded-xl">
                <span className="material-icons-round text-[2.4rem] text-[#e74c3c]">
                  sentiment_dissatisfied
                </span>
                <p className="text-[1.5rem] text-gray-6 leading-[1.7]">
                  문의 하나 하려고 번호를 저장하고 문자 창을 여는 과정에서
                  <br />
                  흐름이 끊기고 상담 의지가 없어져요.
                </p>
              </div>
              <div className="flex items-start gap-4 p-6 bg-white border border-gray-1 rounded-xl">
                <span className="material-icons-round text-[2.4rem] text-[#e74c3c]">
                  sentiment_dissatisfied
                </span>
                <p className="text-[1.5rem] text-gray-6 leading-[1.7]">
                  내 문자를 읽었는지 알 수 없고, 상담사가 현재 부재중인지 알 수
                  <br />
                  없으니 마냥 기다려야 해요.
                </p>
              </div>
            </div>
          </div>

          {/* Consultant Problem */}
          <div>
            <h3 className="text-[2rem] font-bold mb-4">일일이 문자 쓰다 지치는 상담원</h3>
            <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
              <div className="flex items-start gap-4 p-6 bg-white border border-gray-1 rounded-xl">
                <span className="material-icons-round text-[2.4rem] text-[#e74c3c]">
                  sentiment_dissatisfied
                </span>
                <p className="text-[1.5rem] text-gray-6 leading-[1.7]">
                  단순 반복 문의까지 일일이 문자로 답하느라 정작 중요한 상담은
                  <br />
                  놓치고, CS 인력은 빠르게 지쳐요.
                </p>
              </div>
              <div className="flex items-start gap-4 p-6 bg-white border border-gray-1 rounded-xl">
                <span className="material-icons-round text-[2.4rem] text-[#e74c3c]">
                  sentiment_dissatisfied
                </span>
                <p className="text-[1.5rem] text-gray-6 leading-[1.7]">
                  상담 히스토리 파일이 안 되어 매번 처음부터 물어봐야 하고,
                  <br />
                  담당자가 바뀌면 대화 흐름이 끊 끊겨요.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Demo Section */}
        <section className="mb-[80px]">
          <div className="mb-6">
            <Badge size="md" color="white" className="bg-[#1972D2]">
              실제 도입 화면
            </Badge>
          </div>
          <div className="flex flex-col items-center gap-12 mt-12 mb-20 md:flex-row">
            <div className="flex-1">
              <img
                src="/img/business/aicc/aicc_01.png"
                alt="메시지 서비스"
                className="w-full rounded-2xl"
              />
            </div>
            <div>
              <SectionTitle
                title={
                  <>
                    고객과 만나는
                    <br />
                    가장 빠른 방법
                    <br />
                    문자콜센터가 해결합니다.
                  </>
                }
                className="mb-6"
              />
              <p className="text-[1.6rem]  mb-8 leading-[1.6]">
                별도의 설치·개발·장비없이
                <br />
                코드 한줄이면 되니까
              </p>
              <Button variant="custom" size="lg" className="text-white bg-gray-800">
                <Link to="/business/messaging">서비스 신청하기</Link>
              </Button>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section className="mb-[80px]">
          <div className="mb-6">
            <Badge size="md" color="white" className="bg-[#1972D2]">
              특징
            </Badge>
          </div>
          <div className="bg-[#757575] rounded-3xl p-8 lg:p-12">
            <div className="grid grid-cols-1 gap-8 text-white md:grid-cols-[1fr_auto_1fr_auto_1fr] items-end">
              {/* Feature 1 */}
              <div className="flex flex-col justify-end text-center">
                <div className="mb-6 mx-auto w-[200px]">
                  <img
                    src="/img/business/aicc/aicc_02.png"
                    alt="전화번호 없이 바로 문의"
                    className="w-full"
                  />
                </div>
                <p className="text-[1.5rem] leading-[1.7]">
                  전화번호 따로 입력할 필요 없이
                  <br />
                  웹사이트에서 바로 문의가 가능해요.
                </p>
              </div>

              {/* Arrow 1 */}
              <div className="items-center justify-center hidden md:flex">
                <img src="/img/business/aicc/arrow.png" alt="" className="w-24 opacity-80" />
              </div>

              {/* Feature 2 */}
              <div className="flex flex-col justify-end text-center">
                <div className="mb-6 mx-auto w-[200px]">
                  <img
                    src="/img/business/aicc/aicc_03.png"
                    alt="자동 답변 설정"
                    className="w-full"
                  />
                </div>
                <p className="text-[1.5rem] leading-[1.7]">
                  자주 묻는 질문은 자동 답변으로 설정해
                  <br />
                  상담 시간을 대폭 줄일 수 있어요.
                </p>
              </div>

              {/* Arrow 2 */}
              <div className="items-center justify-center hidden md:flex">
                <img src="/img/business/aicc/arrow.png" alt="" className="w-24 opacity-80" />
              </div>

              {/* Feature 3 */}
              <div className="flex flex-col justify-end text-center">
                <div className="mb-6 mx-auto w-[200px]">
                  <img
                    src="/img/business/aicc/aicc_04.png"
                    alt="실시간 상태 표시"
                    className="w-full"
                  />
                </div>
                <p className="text-[1.5rem] leading-[1.7]">
                  직접 상담 연결부터 실시간 상태 표시까지,
                  <br />
                  상황에 맞는 유연한 대응이 가능해요.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="text-center ">
          <h3 className="text-[2.8rem] font-bold leading-[1.5] mb-2">
            상담은 가볍고, 비즈니스는 확실하게
          </h3>
          <p className="text-[2.8rem] font-bold text-[#032C6D] mb-10">문자콜센터</p>
          <Link
            to="/service/submit"
            className="inline-flex items-center gap-2 px-10 py-4 bg-[#032C6D] text-white text-[1.6rem] font-medium rounded-sm hover:bg-[#1e1d4a] transition-colors"
          >
            서비스 신청하기
          </Link>
        </section>
      </main>
    </Container>
  );
};

export default BusinessAICC;
